<template>
	<div class="task-status">
		<section class="task-status__header">
			<el-link icon="el-icon-back" type="text" :underline="false" @click="onBack">返回</el-link>
			<el-divider direction="vertical"></el-divider>
			<span class="title">任务状态设置</span>
			<div class="group">
				<el-button type="primary" size="small" @click.stop="handleAdd">新增状态</el-button>
			</div>
		</section>
		<section class="task-status__container">
			<table-pagination
			    :data="list"
			    :column="column"
				:total="total"
				:page.sync="listQuery.pageNumber"
				:limit.sync="listQuery.pageSize"
				 @pagination="getList"/>
		</section>
		<el-drawer
			class="breath-operate-table"
		    :title="title" 
		    :visible.sync="dialog_visible"
		    :wrapperClosable="false"
			size="600px"
		    direction="rtl">
			<el-form :model="form" :rules="rules" ref="form" label-width="100px">
				  <el-form-item label="状态名称" prop="statusName">
					<el-input v-model="form.statusName" placeholder="请输入状态名称" :disabled="form.isFixed == 1 && form.statusCode < 100"></el-input>
				  </el-form-item>
				  <el-form-item label="状态代码" prop="statusCode">
				  	<el-input-number v-model="form.statusCode"  :min="0" :disabled="form.isFixed == 1 && form.statusCode < 100"></el-input-number>
				  </el-form-item>
				  <el-form-item label="外呼结果" prop="statusType">
					<el-select v-model="form.statusType" placeholder="请选择外呼结果" :disabled="form.isFixed == 1 && form.statusCode < 100">
					  <el-option label="成功" value="success"></el-option>
					  <el-option label="失败" value="fail"></el-option>
					</el-select>
				  </el-form-item>
				  <el-form-item label="是否启用" prop="statusState">
					   <el-radio-group v-model="form.statusState">
					      <el-radio label="1">是</el-radio>
					      <el-radio label="0">否</el-radio>
					    </el-radio-group>
				  </el-form-item>
				  <el-form-item style="float: right; padding-right: 20px;">
				      <el-button @click.stop="dialog_visible = false">取 消</el-button>
					  <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
				    </el-form-item>
			  </el-form>
			
			</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			 var validateCode = (rule, value, callback) => {
				if (!value) {
				  return callback(new Error('状态码不能为空'));
				}else {
					let index = this.list.findIndex((el) => el.statusCode == value);
					if(index != -1) {
						if(this.title == '新增任务状态') {
							callback('状态码重复');
						}else if(this.list[this.active_index].statusCode != value) {
							callback('状态码重复');
						}else {
							callback();
						}
					}else {
						callback();
					}
				}
			};
			return {
				loading:false,
				list: [],
				column:[
					{ label: '外呼结果', prop: 'statusType' ,render:(h,scope) => {return <span>{scope.row.statusType == 'success' ? '成功':'失败'}</span>}},
					{ label: '任务状态', prop: 'statusName' },
					{ label: '是否启用', prop: 'isFixed' ,render:(h,scope) => {return <span>{scope.row.statusState == 1 ? '是' :'否'}</span>}},
					{ 
						label: '操作',
						prop: 'cation',
						align: 'center',
						width: 180,
						fixed: 'right',
						render: (h, scope) => {
							return (
								<div>
									<el-link onClick={() => this.handleEdit(scope.row,scope.$index)} type="text">修改</el-link>
									<el-divider direction="vertical"></el-divider>
									<el-link onClick={() => this.handleDelete(scope.row)} type="danger" 
									disabled={scope.row.isFixed == 1 && scope.row.statusCode < 100 }>删除</el-link>
								</div>
							)
						}
					},
				],
				dialog_visible:false,
				title:'新增任务状态',
				form:{
					id:'',
					statusName:'',
					statusCode:'',
					statusType:'success',
					isFixed:'',
					statusState :'1',
					brandIdentify:''
				},
				rules:{
					statusName:[{required:true,message:'请输入状态名称',trigger:'blur'}],
					statusCode:[{validator: validateCode,trigger:'change'}],
				},
				listQuery:{
					pageNumber: 1,
					pageSize: 100,
					brandIdentify:''
				},
				total:0,
				active_index:-1
			}
		},
		methods: {
			handleDelete(row){
				this.$confirm('删除后将无法恢复, 是否继续?', '系统提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.deleteBreathTaskStatus(row).then(response => {
						if(response.errcode != 0) return;
						this.$notify.succes('删除成功');
						this.getList();
					});
				}).catch(() => {});
			},
			handleEdit(row,index){
				this.title = '编辑任务状态';
				this.dialog_visible = true;
				this.active_index = index;
				this.$nextTick(() => {
					this.$refs.form.resetFields();
					Object.keys(this.form).map(item => {
						this.form[item] = row[item]
					})
				})
			},
			handleAdd(){
				this.title = '新增任务状态';
				this.form = {
					id:'',
					statusName:'',
					statusCode:'',
					statusType:'success',
					isFixed:'',
					statusState :'1',
					brandIdentify:''
				}
				this.dialog_visible = true;
				this.$nextTick(() => {
					this.$refs.form.resetFields();
				})
			},
			onSubmit(){
				this.$refs.form.validate((valid) => {
					if(valid) {
						this.loading = true;
						this.form.brandIdentify = this.$store.getters.userInfo.brandIdentify;
						if(this.title == '新增任务状态'){
							this.$api.addBreathTaskStatus(this.form).then(res => {
								this.loading = false;
								if(res.errcode != 0) return;
								this.$notify.success('新增成功');
								this.dialog_visible = false;
								this.getList();
							}).catch(err => {
								this.loading = false;
							})
						}else {
							this.$api.editBreathTaskStatus(this.form).then(res => {
								this.loading = false;
								if(res.errcode != 0) return;
								this.$notify.success('编辑成功');
								this.dialog_visible = false;
								this.getList();
							}).catch(err => {
								this.loading = false;
							})
						}
					}
				})
			},
			getList() {
				this.listQuery.brandIdentify = this.$store.getters.userInfo.brandIdentify;
				this.$api.getBreathTaskStatus(this.listQuery).then(res => {
					if(res.errcode != 0) return;
					this.list = res.data.filter(el => el.statusCode > 1);
					this.total = Number(res.total);
				})
			},
			onBack(){
				this.$router.go(-1)
			},
		},
		created(){
			this.getList()
		}
	}
</script>

<style lang="scss" scoped>
	.task-status {
		width: 100%;
		height: 100%;
		overflow: hidden;
		padding: 5px 10px;
	
		&__header {
			width: 100%;
			height: 40px;
			line-height: 40px;
			padding: 0 5px;
	
			& .el-link {
				vertical-align: top;
				color: #303133;
			}
	
			& .el-divider {
				vertical-align: top;
				margin-top: 13px;
			}
	
			& > .title {
				font-size: 14px;
				font-weight: bold;
				color: #303133;
				vertical-align: top;
				letter-spacing: .5px;
			}
	
			& > .group {
				height: 100%;
				float: right;
				
				& .el-button {
					vertical-align: top;
					margin-top: 5px;
				}
			}
		}
	
		&__container {
			width: 100%;
			height: calc(100% - 40px);
			overflow: auto;
		}
	}
</style>
